import React from 'react';
import { IMAGE_PATHS } from '../config/images';

const HeroSection = () => {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section id="hero" className="mgs-hero">
      <div className="mgs-hero__inner">
        <div className="mgs-hero__main">
          <div className="mgs-hero__text">
            <h1 className="mgs-hero__headline">
              <span className="mgs-hero__headline-top">Você já conhece o poder das</span>
              <span className="mgs-hero__headline-gold">gotinhas</span>
            </h1>
            <h2 className="mgs-hero__subheadline">
              que auxiliam o metabolismo e ajudam seu corpo a queimar calorias?
            </h2>
            <p className="mgs-hero__desc">
              Fórmula exclusiva com <strong>5 ativos 100% naturais</strong> que ajudam a{' '}
              <strong>controlar a fome, reduzir o inchaço e estimular o metabolismo</strong>,
              facilitando sua jornada de emagrecimento.
            </p>

            <button className="mgs-hero__cta" onClick={scrollToOffer}>
              <i className="fas fa-tint"></i>
              QUERO EMAGRECER AGORA
            </button>

          </div>

          <div className="mgs-hero__image">
            <img src={IMAGE_PATHS.heroWoman} alt="Mulher segurando o Magrisim" className="mgs-hero__img" />
          </div>
        </div>

        <div className="mgs-hero__card">
          <div className="mgs-hero__features">
            <div className="mgs-hero__feature">
              <i className="fas fa-shield-alt"></i>
              <span>Sem efeitos<br />colaterais</span>
            </div>
            <div className="mgs-hero__feature">
              <i className="fas fa-award"></i>
              <span>Regularizado<br />pela Anvisa</span>
            </div>
            <div className="mgs-hero__feature">
              <span className="mgs-hero__feature-real">R$</span>
              <span>Menos de<br />4 reais por dia</span>
            </div>
            <div className="mgs-hero__feature">
              <i className="fas fa-tint"></i>
              <span>Apenas<br />20 gotinhas</span>
            </div>
          </div>

          <div className="mgs-hero__callouts-wrap">
            <div className="mgs-hero__callouts">
              <div className="mgs-hero__callout">
                <i className="fas fa-clock"></i>
                <p>Cada dia que passa é mais um dia <strong>longe</strong> do corpo que você quer.</p>
              </div>
              <div className="mgs-hero__callout">
                <i className="fas fa-shopping-cart"></i>
                <p><strong>Garanta já</strong> o seu Magrisim.</p>
              </div>
            </div>
            <div className="mgs-hero__seal">
              <img src={IMAGE_PATHS.seloAnvisa} alt="Produto regularizado pela Anvisa" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
